"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styles_1 = require("./styles");
const AlternativeContent = ({ children }) => {
    return (0, jsx_runtime_1.jsx)(styles_1.Root, { children: children });
};
exports.default = AlternativeContent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWx0ZXJuYXRpdmVDb250ZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FsdGVybmF0aXZlLWNvbnRlbnQvQWx0ZXJuYXRpdmVDb250ZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxxQ0FBZ0M7QUFNaEMsTUFBTSxrQkFBa0IsR0FBRyxDQUFDLEVBQUUsUUFBUSxFQUFTLEVBQUUsRUFBRTtJQUNqRCxPQUFPLHVCQUFDLGFBQUksY0FBRSxRQUFRLEdBQVEsQ0FBQztBQUNqQyxDQUFDLENBQUM7QUFFRixrQkFBZSxrQkFBa0IsQ0FBQyJ9